import * as Sentry from "@sentry/react";
import { isTestEnvironmentRunning } from "sonobello.utilities.react";
import {
  ITelemetryClient,
  ITelemetryContext,
  ITelemetryRecord,
  SentryTelemetryClient,
  TelemetryRecorder
} from "sonobello.utilities.react.telemetry";
import LoggedSentryTelemetryClient from "sonobello.utilities.react.telemetry/dist/Types/LoggedSentryTelemetryClient";

import EnvironmentConfiguration from "../../../constants/EnvironmentConfiguration";
import { TelemetrySessionTags, TelemetryUserTags } from "../Types/ITelemetryClient";

/** The telemetry instance that will track and log all telemetry messages for use by test assertions. */
const testingTelemetry = new TelemetryRecorder<TelemetryUserTags, TelemetrySessionTags>();

const TestingTelemetryClient: ITelemetryClient<TelemetrySessionTags> &
  ITelemetryRecord<TelemetryUserTags, TelemetrySessionTags> = testingTelemetry;

export { TestingTelemetryClient };

/** The telemetry instance used by the application.
 * @remarks will set the instance to {@link TestingTelemetryClient} if Cypress is running, a version which sends to
 * Sentry otherwise, and adds console.logging if env name is 'local'.
 */
const TelemetryClient: ITelemetryClient<TelemetrySessionTags> &
  ITelemetryContext<TelemetryUserTags, TelemetrySessionTags> = isTestEnvironmentRunning()
  ? testingTelemetry
  : EnvironmentConfiguration.name === "Local"
  ? new LoggedSentryTelemetryClient<TelemetryUserTags, TelemetrySessionTags>(Sentry)
  : new SentryTelemetryClient<TelemetryUserTags, TelemetrySessionTags>(Sentry);

export default TelemetryClient;
